import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./refresh-view-application.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./refresh-view-application.component.scss?ngResource";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AppControllerService } from "../../../app-controller.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { ViewApplicationRoutingConstants } from "../../../view-application/view-application-routing.constants";
let RefreshViewApplicationComponent = class RefreshViewApplicationComponent {
    router;
    appController;
    constructor(router, appController) {
        this.router = router;
        this.appController = appController;
    }
    ngOnInit() {
        this.router.navigate([AppRoutingConstants.createRouteToView(this.appController.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, this.appController.selectedJobID + "")]).then((r) => {
        });
    }
    static ctorParameters = () => [
        { type: Router },
        { type: AppControllerService }
    ];
};
RefreshViewApplicationComponent = __decorate([
    Component({
        selector: "app-refresh-view-application",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], RefreshViewApplicationComponent);
export { RefreshViewApplicationComponent };
